import HomeAreasCards from './Cards';
import styles from './styles.module.scss';
import { sectionsRefer } from '@/enums/sectionsRefer';
import useTranslation from 'next-translate/useTranslation';
import { TransTextWithDefault, Animation } from '@starsoft/common/components';

export default function HomeAreas() {
  const { t } = useTranslation('common');

  return (
    <div id={sectionsRefer.company} className={styles.container}>
      <div className={styles.container__content}>
        <div className={styles.container__content__heading}>
          <div className={styles.container__content__heading__title}>
            <Animation type="fadeInDown">
              <TransTextWithDefault text={t('home_heading')} />
            </Animation>
          </div>
          <div className={styles.container__content__heading__description}>
            <Animation type="fadeInUp">{t('home_description')}</Animation>
          </div>
        </div>
        <HomeAreasCards />
      </div>
    </div>
  );
}
